import { Component, OnInit, Input, OnChanges } from '@angular/core';

@Component({
  selector: 'app-header-certificado',
  templateUrl: './header-certificado.component.html',
  styleUrls: ['./header-certificado.component.css']
})
export class HeaderCertificadoComponent implements OnChanges {

  @Input() public nit : string = "";
  @Input() public imagenLogo : string = "";

  constructor() { }

  ngOnChanges() {
    this.getData();
  }

  private async getData() {
    try {
      await this.nit;
      await this.imagenLogo;
    } catch(exception) {
      console.log(exception);
    }
  }

}
